// extracted by mini-css-extract-plugin
export var backgroundImage = "SolutionsHeroSection-module--backgroundImage--bdfc5";
export var content = "SolutionsHeroSection-module--content--1696b";
export var cta = "SolutionsHeroSection-module--cta--bb64c";
export var wraper = "SolutionsHeroSection-module--wraper--82b48";
export var wrapper = "SolutionsHeroSection-module--wrapper--4f845";